import React from 'react';
import './MainSlider.scss';
import Container from 'reactor/components/Grid/ContainerWithWidth'
import GridItem from 'reactor/components/Grid/GridItem';
import BoxItem from 'reactor/components/Box';
import Image from 'reactor/components/Image';
import Rowaad from 'assets/images/main-img.webp'
import RowaadMob from 'assets/images/rowaad-mob.webp'
import apps from 'assets/images/apps.webp'
import eccommerce from 'assets/images/eccommerce.webp'
import websites from 'assets/images/websites.webp'
import Slider from "react-slick";
import { useMediaQuery } from '@material-ui/core';
import { link } from 'fs';

const sliderContent = [
    {
        title: "هوية بصرية</br> ترسخ في الأذهان",
        subtitle: "أجعلها زيارة لا تُنسى.",
        img: Rowaad,
        mobImg: RowaadMob,
        href: "/"
    },
    {
        title: "نستخدم أحدث </br> التقنيات لتنفيذ أقوى التطبيقات",
        subtitle: "لإرتياد مجالك.",
        img: apps,
        mobImg: apps,
        href: "/apps"
    },
    {
        title: " متجر إلكتروني</br>  متعدد اللغات ووسائل الدفع",
        subtitle: "لزوار من جميع أنحاء العالم.",
        img: eccommerce,
        mobImg: eccommerce,
        hrefOut : "https://products.rh.net.sa/store/web/",
    },
    {
        title: "تصميمات</br> مبهرة واحترافية لموقعك ",
        subtitle: "تجعلك مميز بين منافسيك.",
        img: websites,
        mobImg: websites,
        href: "/webdesign"
    },
]

const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 6000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };


export default function MainSlider() {
    const mobileMatches = useMediaQuery(theme => theme.breakpoints.down('768'));

    return (
        <div id="main__section">
            <Slider {...settings}>
                {sliderContent.map( (item, index)=> (
                <a key={"slide" + index} href={item.href ? item.href : item.hrefOut} target={item.hrefOut ? "_blank" : ""}>
                    <Container key={index} justify="space-between" alignItems="center">
                        <GridItem xs={6}>
                            <BoxItem className="main__section--right">
                                <div className="main__section--right--inner">
                                    <h2 className="main__section--title" dangerouslySetInnerHTML={{__html:item.title}}></h2>
                                    <p className="main__section--content lightFont__smallSize" dangerouslySetInnerHTML={{__html:item.subtitle}}></p>
                                </div>
                            </BoxItem>
                        </GridItem>
                        <GridItem xs={6}>
                            <BoxItem className="main__section--left">
                                <Image src={mobileMatches ? item.mobImg : item.img} alt={item.title} />
                            </BoxItem>
                        </GridItem>
                    </Container>
                </a>
                    )
                )}
            </Slider>
        </div>
    )
}